/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_requestUsersInvitations_requestDeleteRequestUserInvitation } from '../models/api_requestUsersInvitations_requestDeleteRequestUserInvitation';
import type { api_requestUsersInvitations_requestGetRequestUserInvitationByToken } from '../models/api_requestUsersInvitations_requestGetRequestUserInvitationByToken';
import type { api_requestUsersInvitations_requestListInvitations } from '../models/api_requestUsersInvitations_requestListInvitations';
import type { api_requestUsersInvitations_requestResendInvitation } from '../models/api_requestUsersInvitations_requestResendInvitation';
import type { api_requestUsersInvitations_requestSaveInvitations } from '../models/api_requestUsersInvitations_requestSaveInvitations';
import type { api_requestUsersInvitations_requestSendInvitationRequest } from '../models/api_requestUsersInvitations_requestSendInvitationRequest';
import type { api_requestUsersInvitations_responseDeleteRequestUserInvitation } from '../models/api_requestUsersInvitations_responseDeleteRequestUserInvitation';
import type { api_requestUsersInvitations_responseGetRequestUserInvitationByToken } from '../models/api_requestUsersInvitations_responseGetRequestUserInvitationByToken';
import type { api_requestUsersInvitations_responseListInvitations } from '../models/api_requestUsersInvitations_responseListInvitations';
import type { api_requestUsersInvitations_responseResendInvitation } from '../models/api_requestUsersInvitations_responseResendInvitation';
import type { api_requestUsersInvitations_responseSaveInvitations } from '../models/api_requestUsersInvitations_responseSaveInvitations';
import type { api_requestUsersInvitations_responseSendInvitationRequest } from '../models/api_requestUsersInvitations_responseSendInvitationRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RequestUserInvitationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Delete RequestUserInvitation
     * Delete RequestUserInvitation
     * @returns api_requestUsersInvitations_responseDeleteRequestUserInvitation responseDeleteRequestUserInvitation
     * @throws ApiError
     */
    public postRequestUserInvitationDelete({
        body,
    }: {
        /**
         * requestDeleteRequestUserInvitation
         */
        body: api_requestUsersInvitations_requestDeleteRequestUserInvitation,
    }): CancelablePromise<api_requestUsersInvitations_responseDeleteRequestUserInvitation> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_invitation/delete',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get RequestUserInvitation By Token
     * Get RequestUserInvitation By Token
     * @returns api_requestUsersInvitations_responseGetRequestUserInvitationByToken responseGetRequestUserInvitationByToken
     * @throws ApiError
     */
    public postRequestUserInvitationGetByToken({
        body,
    }: {
        /**
         * requestGetRequestUserInvitationByToken
         */
        body: api_requestUsersInvitations_requestGetRequestUserInvitationByToken,
    }): CancelablePromise<api_requestUsersInvitations_responseGetRequestUserInvitationByToken> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_invitation/get_by_token',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List User Invitations
     * Retrieves invitations for a specific organization
     * @returns api_requestUsersInvitations_responseListInvitations Successful response
     * @throws ApiError
     */
    public postRequestUserInvitationList({
        body,
    }: {
        /**
         * requestListInvitations
         */
        body: api_requestUsersInvitations_requestListInvitations,
    }): CancelablePromise<api_requestUsersInvitations_responseListInvitations> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_invitation/list',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Resend user invitation
     * 利用ユーザーの招待を再送する
     * @returns api_requestUsersInvitations_responseResendInvitation responseResendInvitation
     * @throws ApiError
     */
    public postRequestUserInvitationResend({
        body,
    }: {
        /**
         * requestResendInvitation
         */
        body: api_requestUsersInvitations_requestResendInvitation,
    }): CancelablePromise<api_requestUsersInvitations_responseResendInvitation> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_invitation/resend',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save multiple user invitations
     * Saves multiple user invitations at once
     * @returns api_requestUsersInvitations_responseSaveInvitations Successful response
     * @throws ApiError
     */
    public postRequestUserInvitationSave({
        body,
    }: {
        /**
         * requestSaveInvitations
         */
        body: api_requestUsersInvitations_requestSaveInvitations,
    }): CancelablePromise<api_requestUsersInvitations_responseSaveInvitations> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_invitation/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Send Invitation Request
     * 利用ユーザーの招待依頼を送信する。
     * @returns api_requestUsersInvitations_responseSendInvitationRequest responseSendInvitationRequest
     * @throws ApiError
     */
    public postRequestUserInvitationSendInvitationRequest({
        body,
    }: {
        /**
         * requestSendInvitationRequest
         */
        body: api_requestUsersInvitations_requestSendInvitationRequest,
    }): CancelablePromise<api_requestUsersInvitations_responseSendInvitationRequest> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/request_user_invitation/send_invitation_request',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
